import { render, staticRenderFns } from "./SalesPaymentStatusBadge.vue?vue&type=template&id=aba6a4f4&"
import script from "./SalesPaymentStatusBadge.vue?vue&type=script&lang=js&"
export * from "./SalesPaymentStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports